export const BASE_URL = window.location.origin;

export const getMotorcycleOptions = async ({ make, year }) => {
  let url = `${BASE_URL}/wp-json/bluebook/v1/query?type=Motorcycle`;
  if (make && !year) url += `&manu=${make}`;
  if (make && year) url += `&manu=${make}&year=${year}`;
  try {
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
    });
    const data = await response.json();
    return data;
  } catch (error) {
    return false;
  }
};

export const getMotorcycleQuote = async ({ make, year, model }) => {
  let url = `${BASE_URL}/wp-json/bluebook/v1/type/Motorcycle/manu/${make}/year/${year}/model/${model}/go`;
  try {
    const response = await fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });
    const data = await response.json();
    return data;
  } catch (error) {
    return false;
  }
};
